const firebaseConfig = {
  apiKey: "AIzaSyAcTVMq2m8nDUfyAB67ePkZO_bS5gcZDTo",
  authDomain: "crypto-tracker-f6b24.firebaseapp.com",
  projectId: "crypto-tracker-f6b24",
  storageBucket: "crypto-tracker-f6b24.appspot.com",
  messagingSenderId: "344381381667",
  appId: "1:344381381667:web:053385d1a5b21851076596"
};

export default firebaseConfig;
